import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ROUTES } from "./ConstantRoute";
import Login from "Login";
import React from "react";
import UnprotectedRoutes from "Config/UnprotectedRoutes";
import ProtectedRoutes from "Config/ProtectedRoutes";
import { TopBar } from "Component/TopBar";
import { TopBarProfile } from "Component/TopBar";
import DashboardHome from "DashboardManagementPlatform/DashboardHome";
import JurisdictionLevel from "DashboardManagementPlatform/MasterData/JurisdictionLevel";
import Gender from "DashboardManagementPlatform/MasterData/Gender";
import OperationStatus from "DashboardManagementPlatform/MasterData/OperationStatus";
import BloodType from "DashboardManagementPlatform/MasterData/BloodType";
import Religion from "DashboardManagementPlatform/MasterData/Religion";
import MaritalStatus from "DashboardManagementPlatform/MasterData/MaritalStatus";
import Nationality from "DashboardManagementPlatform/MasterData/Nationality";
import DeviceType from "DashboardManagementPlatform/MasterData/DeviceType";
import NotFoundPage from "NotFoundPage";
import Organization from "DashboardManagementPlatform/MasterData/Organization/Home";
import PermissionGroup from "DashboardManagementPlatform/MasterData/PermissionGroup/Home";
import UserAccess from "DashboardManagementPlatform/ManagementData/User/Home";
import CreateOrganization from "DashboardManagementPlatform/MasterData/Organization/Create";
import UpdateOrganization from "DashboardManagementPlatform/MasterData/Organization/Update";
import InformationProfile from "Profile/Information";
import PasswordProfile from "Profile/Password";
import OperationPolice from "../DashboardManagementPlatform/ManagementData/OperationPolice/Home";
import CreateOperationPolice from "DashboardManagementPlatform/ManagementData/OperationPolice/Create";
import UpdateOperationPolice from "DashboardManagementPlatform/ManagementData/OperationPolice/Update";
import DockingStationSettings from "../DashboardManagementPlatform/ManagementData/DockingStationSettings/Home";
import CreateDockingStationSettings from "DashboardManagementPlatform/ManagementData/DockingStationSettings/Create";
import UpdateDockingStationSettings from "DashboardManagementPlatform/ManagementData/DockingStationSettings/Update";
import StreamingSettings from "DashboardManagementPlatform/ManagementData/StreamingSettings/Home";
import CreateStreamingDevice from "DashboardManagementPlatform/ManagementData/StreamingSettings/Create";
import UpdateStreamingDevice from "DashboardManagementPlatform/ManagementData/StreamingSettings/Update";
import LayoutMonitoring from "Monitoring/LayoutMonitoring";
import CreatePermissionGroup from "DashboardManagementPlatform/MasterData/PermissionGroup/Create";
import UpdatePermissionGroup from "DashboardManagementPlatform/MasterData/PermissionGroup/Update";
import { EncryptStorage } from "encrypt-storage";
import RegisterFace from "DashboardManagementPlatform/ManagementData/RegisterFace/Home";
import CreateRegisterFace from "DashboardManagementPlatform/ManagementData/RegisterFace/Create";
import CreateUser from "DashboardManagementPlatform/ManagementData/User/Create";
import UpdateUser from "DashboardManagementPlatform/ManagementData/User/Update";
import { License } from "DashboardManagementPlatform/License";
import { DetailLicense } from "DashboardManagementPlatform/License/DetailLicense";
import WatchlistHome from "DashboardManagementPlatform/ManagementData/Watchlist/Home";
import UpdateWatchlist from "DashboardManagementPlatform/ManagementData/Watchlist/Update";
import CreateWatchlist from "DashboardManagementPlatform/ManagementData/Watchlist/Create";
import UpdateRegisterFace from "DashboardManagementPlatform/ManagementData/RegisterFace/Update";
import PlaybackSettings from "DashboardManagementPlatform/ManagementData/Playback/Home";
import CreatePlaybackSettings from "DashboardManagementPlatform/ManagementData/Playback/Create";
import UpdatePlaybackSettings from "DashboardManagementPlatform/ManagementData/Playback/Update";
import Report from "DashboardManagementPlatform/Report/Home";
import CameraInventory from "DashboardManagementPlatform/Inventory/CameraInventory/Home";
import CreateCameraInventory from "DashboardManagementPlatform/Inventory/CameraInventory/Create";
import VehicleInventory from "DashboardManagementPlatform/Inventory/VehicleInventory/Home";
import CreateVehicleInventory from "DashboardManagementPlatform/Inventory/VehicleInventory/Create";
import UpdateVehicleInventory from "DashboardManagementPlatform/Inventory/VehicleInventory/Update";
import UpdateCameraInventory from "DashboardManagementPlatform/Inventory/CameraInventory/Update";
import LogActivity from "DashboardManagementPlatform/LogActivity/Home";
import { ReportDetail } from "DashboardManagementPlatform/Report/Detail";
function PathRouter() {
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const permission_flag =
    userInfo?.permission_flag !== undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  return (
    <div>
      <Router>
        <Routes>
          <Route
            path={ROUTES.auth.login}
            element={
              <UnprotectedRoutes>
                <Login />
              </UnprotectedRoutes>
            }
          />
          <Route
            path={ROUTES.live_monitoring}
            element={
              <ProtectedRoutes>
                <LayoutMonitoring />
              </ProtectedRoutes>
            }
          >
            <Route path="/monitoring/playback" />
            <Route path="/monitoring/live" />
          </Route>

          <Route
            path="/"
            element={
              <ProtectedRoutes>
                <TopBar />
              </ProtectedRoutes>
            }
          >
            <Route path="*" element={<NotFoundPage />} />
            <Route path={ROUTES.dashboard} element={<DashboardHome />} />
            <Route path={ROUTES.report.report_home} element={<Report />} />
            <Route path={ROUTES.report.report_detail} element={<ReportDetail />} />

            {/* ========================================================================= */}
            {/* Master Data Route */}
            {yuridiksi_user_code === "N" ? (
              <>
                <Route
                  path={ROUTES.master_data.organization.organization_home}
                  element={<Organization />}
                />
                <Route
                  path={ROUTES.master_data.organization.organization_create}
                  element={<CreateOrganization />}
                />
                <Route
                  path={ROUTES.master_data.organization.organization_update}
                  element={<UpdateOrganization />}
                />
                <Route
                  path={
                    ROUTES.master_data.permission_group.permission_group_home
                  }
                  element={<PermissionGroup />}
                />
                <Route
                  path={
                    ROUTES.master_data.permission_group.permission_group_create
                  }
                  element={<CreatePermissionGroup />}
                />
                <Route
                  path={
                    ROUTES.master_data.permission_group.permission_group_update
                  }
                  element={<UpdatePermissionGroup />}
                />
                <Route
                  path={
                    ROUTES.master_data.jurisdiction_level
                      .jurisdiction_level_home
                  }
                  element={<JurisdictionLevel />}
                />
                <Route
                  path={ROUTES.master_data.gender.gender_home}
                  element={<Gender />}
                />
                <Route
                  path={
                    ROUTES.master_data.operation_status.operation_status_home
                  }
                  element={<OperationStatus />}
                />
                <Route
                  path={ROUTES.master_data.blood_type.blood_type_home}
                  element={<BloodType />}
                />
                <Route
                  path={ROUTES.master_data.religion_type.religion_type_home}
                  element={<Religion />}
                />
                <Route
                  path={ROUTES.master_data.marital_type.marital_type_home}
                  element={<MaritalStatus />}
                />
                <Route
                  path={
                    ROUTES.master_data.nationality_type.nationality_type_home
                  }
                  element={<Nationality />}
                />
                <Route
                  path={ROUTES.master_data.device_type.device_type_home}
                  element={<DeviceType />}
                />
              </>
            ) : null}

            {/* ========================================================================= */}
            {/* Management Data Route */}

            {/* STREAMING DEVICE */}
            <Route
              path={
                ROUTES.management_data.streaming_device.streaming_device_home
              }
              element={<StreamingSettings />}
            />
            {permission_flag?.streaming?.addData &&
            permission_flag?.streaming?.addData === true ? (
              <>
                <Route
                  path={
                    ROUTES.management_data.streaming_device
                      .streaming_device_create
                  }
                  element={<CreateStreamingDevice />}
                />
              </>
            ) : null}
            {permission_flag?.streaming?.updateData &&
            permission_flag?.streaming?.updateData === true ? (
              <>
                <Route
                  path={
                    ROUTES.management_data.streaming_device
                      .streaming_device_update
                  }
                  element={<UpdateStreamingDevice />}
                />
              </>
            ) : null}
            {/* STREAMING DEVICE */}

            {/* DOCKING STATION */}
            <Route
              path={ROUTES.management_data.docking_station.docking_station_home}
              element={<DockingStationSettings />}
            />
            {permission_flag?.docking_station?.addData &&
            permission_flag?.docking_station?.addData === true ? (
              <>
                <Route
                  path={
                    ROUTES.management_data.docking_station
                      .docking_station_create
                  }
                  element={<CreateDockingStationSettings />}
                />
              </>
            ) : null}
            {permission_flag?.docking_station?.updateData &&
            permission_flag?.docking_station?.updateData === true ? (
              <>
                <Route
                  path={
                    ROUTES.management_data.docking_station
                      .docking_station_update
                  }
                  element={<UpdateDockingStationSettings />}
                />
              </>
            ) : null}

            {/* DOCKING STATION */}

            {/* PLAYBACK SETTINGS */}
            <Route
              path={ROUTES.management_data.playback.playback_home}
              element={<PlaybackSettings />}
            />
            {permission_flag?.playback?.addData &&
            permission_flag?.playback?.addData === true ? (
              <>
                <Route
                  path={ROUTES.management_data.playback.playback_create}
                  element={<CreatePlaybackSettings />}
                />
              </>
            ) : null}
            {permission_flag?.playback?.updateData &&
            permission_flag?.playback?.updateData === true ? (
              <>
                <Route
                  path={ROUTES.management_data.playback.playback_update}
                  element={<UpdatePlaybackSettings />}
                />
              </>
            ) : null}

            {/* PLAYBACK SETTINGS */}

            {/* WATCHLIST */}
            <Route
              path={ROUTES.management_data.watchlist.watchlist_home}
              element={<WatchlistHome />}
            />
            {permission_flag?.dpo?.addData &&
            permission_flag?.dpo?.addData === true ? (
              <>
                <Route
                  path={ROUTES.management_data.watchlist.watchlist_create}
                  element={<CreateWatchlist />}
                />
              </>
            ) : null}
            {permission_flag?.dpo?.updateData &&
            permission_flag?.dpo?.updateData === true ? (
              <>
                <Route
                  path={ROUTES.management_data.watchlist.watchlist_update}
                  element={<UpdateWatchlist />}
                />
              </>
            ) : null}

            {/* WATCHLIST */}

            {/* REGISTER FACE */}
            <Route
              path={ROUTES.management_data.RegisterFace.register_face_home}
              element={<RegisterFace />}
            />
            {permission_flag?.register_face?.addData &&
            permission_flag?.register_face?.addData === true ? (
              <>
                <Route
                  path={
                    ROUTES.management_data.RegisterFace.register_face_create
                  }
                  element={<CreateRegisterFace />}
                />
              </>
            ) : null}
            {permission_flag?.register_face?.updateData &&
            permission_flag?.register_face?.updateData === true ? (
              <>
                <Route
                  path={
                    ROUTES.management_data.RegisterFace.register_face_update
                  }
                  element={<UpdateRegisterFace />}
                />
              </>
            ) : null}
            {/* REGISTER FACE */}

            {/* CAMERA INVENTORY */}
            <Route
              path={ROUTES.inventory.camera.camera_home}
              element={<CameraInventory />}
            />

            <Route
              path={ROUTES.inventory.camera.camera_create}
              element={<CreateCameraInventory />}
            />

            <Route
              path={ROUTES.inventory.camera.camera_update}
              element={<UpdateCameraInventory />}
            />

            {/* CAMERA INVENTORY */}

            {/* VEHICLE INVENTORY */}
            <Route
              path={ROUTES.inventory.vehicle.vehicle_home}
              element={<VehicleInventory />}
            />

            <Route
              path={ROUTES.inventory.vehicle.vehicle_create}
              element={<CreateVehicleInventory />}
            />

            <Route
              path={ROUTES.inventory.vehicle.vehicle_update}
              element={<UpdateVehicleInventory />}
            />

            {/* VEHICLE INVENTORY */}
            {/* LOG ACTIVITY */}
            <Route
              path={ROUTES.log_activity.log_activity_home}
              element={<LogActivity />}
            />
            {/* LOG ACTIVITY */}

            {/* LICENSE */}
            <Route path={ROUTES.license.license_home} element={<License />} />
            <Route
              path={ROUTES.license.license_detail}
              element={<DetailLicense />}
            />
            {/* LICENSE */}

            {/* OPERATION */}
            <Route
              path={
                ROUTES.management_data.OperationPolice.operation_police_home
              }
              element={<OperationPolice />}
            />
            <Route
              path={
                ROUTES.management_data.OperationPolice.operation_police_create
              }
              element={<CreateOperationPolice />}
            />
            <Route
              path={
                ROUTES.management_data.OperationPolice.operation_police_update
              }
              element={<UpdateOperationPolice />}
            />
            {/* OPERATION */}

            {/* USER */}
            <Route
              path={ROUTES.management_data.user_access.user_access_home}
              element={<UserAccess />}
            />
            <Route
              path={ROUTES.management_data.user_access.user_access_create}
              element={<CreateUser />}
            />
            <Route
              path={ROUTES.management_data.user_access.user_access_update}
              element={<UpdateUser />}
            />
          </Route>

          <Route
            path="/"
            element={
              <ProtectedRoutes>
                <TopBarProfile />
              </ProtectedRoutes>
            }
          >
            <Route
              path={ROUTES.profile.information}
              element={<InformationProfile />}
            />
            <Route
              path={ROUTES.profile.password}
              element={<PasswordProfile />}
            />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default PathRouter;
